import { render } from "./WallPaper.vue?vue&type=template&id=86289038&scoped=true"
import script from "./WallPaper.vue?vue&type=script&lang=js"
export * from "./WallPaper.vue?vue&type=script&lang=js"

import "./WallPaper.vue?vue&type=style&index=0&id=86289038&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-86289038"

export default script